import React, { useEffect, useState } from "react";
import styled from "styled-components";

const TopButton = styled.button`
  position: fixed;
  bottom: max(24px, env(safe-area-inset-bottom));
  left: 24px;
  z-index: 99;
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border: 1px solid transparent;
  border-radius: 50%;
  padding: 0;
  background: transparent;
  color: #1d1d1f;
  cursor: pointer;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};
  transform: translate3d(0, ${({ $visible }) => ($visible ? "0" : "8px")}, 0);
  pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};
  transition: opacity 220ms ease, transform 260ms cubic-bezier(.22,.61,.36,1),
              visibility 0s linear ${({ $visible }) => ($visible ? "0s" : "260ms")},
              color 180ms ease, background-color 180ms ease;
  -webkit-tap-highlight-color: transparent;
  svg { width: 22px; height: 22px; display: block; transition: transform 220ms cubic-bezier(.22,.61,.36,1); }
  &:hover { color: #000; background: rgba(0,0,0,.06); }
  &:hover svg { transform: translateY(-2px); }
  &:focus-visible { outline: 2px solid #1d1d1f; outline-offset: 3px; }
  @media (max-width: 750px) { left: 16px; bottom: max(16px, env(safe-area-inset-bottom)); }
  @media (prefers-reduced-motion: reduce) {
    &, svg { transition: none; }
    &, &:hover svg { transform: none; }
  }
`;

export default function BackToTopButton() {
  const [visible, setVisible] = useState(() => typeof window !== "undefined" && window.scrollY > 360);
  useEffect(() => {
    let frame = null;
    const update = () => {
      frame = null;
      setVisible(window.scrollY > 360);
    };
    const onScroll = () => {
      if (frame === null) frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (frame !== null) window.cancelAnimationFrame(frame);
    };
  }, []);

  const scrollToTop = () => {
    document.getElementById("history-decade-navigation")?.scrollIntoView({ block: "start", behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
  };

  return (
    <TopButton type="button" $visible={visible} onClick={scrollToTop}
      aria-label="Back to decade selection" title="Jump to decades" tabIndex={visible ? 0 : -1}>
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4.5 15.5 12 8l7.5 7.5" stroke="currentColor" strokeWidth="1.8"
          strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </TopButton>
  );
}
